﻿import React, {ChangeEvent, useCallback} from 'react';
import {SortFilterContainer} from "../../common/reports/sortFilter";
import {AutocompleteChangeReason} from "@mui/material";
import {SortFilterItemContainer} from "../../common/reports/sortFilter";
import {LocationNameAutocomplete} from "../../location/LocationNameAutocomplete";
import {BuyerNameAutocomplete} from "../../buyer/BuyerNameAutocomplete";
import {AutocompleteOption} from "../../SortFilter/interfaces";
import {SupplierCurrentInventorySortSelect} from "./SupplierCurrentInventorySortSelect";
import {SupplierInventorySortByType} from "../../../types/supplier/SupplierInventorySortByType";
import {SortDirType} from "../../../types/common/SortDirType";
import {SortFilterRowContainer} from "../../common/reports/sortFilter";
import {SortFilterTextField} from "../../common/reports/sortFilter";

type SupplierCurrentInventorySortFilterProps = {
  locationId: string;
  onLocationChangeId: (value: string) => void;
  buyerId: string;
  onBuyerChangeId: (value: string) => void;
  equipmentNumber: string;
  onEquipmentNumberChange: (value: string) => void;
  bookingNumber: string;
  onBookingNumberChange: (value: string) => void;
  sort: SupplierInventorySortByType;
  onSortChange: (value: SupplierInventorySortByType) => void;
  sortDir: SortDirType;
  onSortDirChange: (value: SortDirType) => void;
}

const SupplierCurrentInventorySortFilter = ({
  locationId,
  onLocationChangeId,
  buyerId,
  onBuyerChangeId,
  equipmentNumber,
  onEquipmentNumberChange,
  bookingNumber,
  onBookingNumberChange,
  sort,
  onSortChange,
  sortDir,
  onSortDirChange,
}: SupplierCurrentInventorySortFilterProps) => {

  const handleLocationNameChange = useCallback((_event: any, newValue: AutocompleteOption, reason: AutocompleteChangeReason) => {
    if (reason !== 'createOption') {
      onLocationChangeId(newValue.id);
    }
  }, [onLocationChangeId]);

  const handleBuyerNameChange = (_event: any, newValue: AutocompleteOption, reason: AutocompleteChangeReason) => {
    if (reason !== 'createOption') {
      onBuyerChangeId(newValue.id);
    }
  }

  const handleEquipmentNumberChange = (event: ChangeEvent<HTMLInputElement>) => {
    onEquipmentNumberChange(event?.target?.value);
  }

  const handleBookingNumberChange = (event: ChangeEvent<HTMLInputElement>) => {
    const integersOnly = event?.target?.value.replace(/\D/g, "");
    onBookingNumberChange(String(integersOnly));
  }

  return <SortFilterContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <LocationNameAutocomplete value={locationId} onChange={handleLocationNameChange} />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BuyerNameAutocomplete value={buyerId} onChange={handleBuyerNameChange} />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <SortFilterTextField label={'Equipment Number'}
                             value={equipmentNumber}
                             onChange={handleEquipmentNumberChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <SortFilterTextField label={'Booking Number'}
                             value={bookingNumber}
                             onChange={handleBookingNumberChange}
                             inputMode='numeric'
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <SupplierCurrentInventorySortSelect sortBy={sort}
                                            onSortByChange={onSortChange}
                                            sortDir={sortDir}
                                            onSortDirChange={onSortDirChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
  </SortFilterContainer>
}

export { SupplierCurrentInventorySortFilter };
